<template>
  <div class="row-login" style="background-color: #f8f8f8">
    <div class="header-log">
      <div class="wp">
        <div class="logo-log">
          <img v-if="commonConfig.bk_config_signin_logo" :src="commonConfig.bk_config_signin_logo"/>
          <img v-else src="@/assets/images/log/logo2.png" alt="" />
        </div>
        <div class="btns">
          <div class="btn">
            已有账号，<router-link to="/login" class="a">马上登陆</router-link>
          </div>
          <div class="line">|</div>
          <router-link to="/" class="btn a">返回首页</router-link>
        </div>
      </div>
    </div>

    <div class="m-signin1">
      <div class="box">
        <div class="top">{{ title }}</div>
        <div class="inner">
          <div class="m-formg1 m-formg2">
            <form onsubmit="return false;">
              <div class="form">
                <div class="li li2">
                  <div class="info">会员类型： </div>
                  <div class="con">
                  <el-radio-group v-model="type" fill="#333">
                    <el-tooltip effect="dark" placement="bottom"  :disabled="isDisabled" transition="el-fade-in-linear">
                      <div slot="content" class="m-popt1">
                        <div class="top">
                          <div class="info">会员权益</div>
                        </div>
                        <div class="p" v-html="commonConfig.bk_user_description"></div>
                      </div>
                      <el-radio :label="0">普通会员</el-radio>
                    </el-tooltip>
                    <el-tooltip effect="dark" placement="bottom"  :disabled="isDisabled" transition="el-fade-in-linear">
                      <div slot="content" class="m-popt1">
                        <div class="top">
                          <div class="info">会员权益</div>
                        </div>
                        <div class="p" v-html="commonConfig.bk_supplier_description"></div>
                      </div>
                      <el-radio :label="1">供应商会员</el-radio>
                    </el-tooltip>
                    <el-tooltip effect="dark" placement="bottom"  :disabled="isDisabled" transition="el-fade-in-linear">
                      <div slot="content" class="m-popt1">
                        <div class="top">
                          <div class="info">会员权益</div>
                        </div>
                        <div class="p" v-html="commonConfig.bk_chooser_description"></div>
                      </div>
                      <el-radio :label="2">选书会员</el-radio>
                    </el-tooltip>
                  </el-radio-group>
                  </div>
                </div>
                <div class="li">
                  <div class="con">
                    <div class="inpbox">
                      <el-input
                        name="realname"
                        placeholder="请输入您的真实姓名"
                        v-model="username"
                        class="inp"
                      ></el-input>
                    </div>
                  </div>
                </div>
                <div class="li li2">
                  <div class="con con-num">
                    <div class="left">
                      <el-select v-model="value" placeholder="请选择">
                        <el-option
                          v-for="item in options"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </div>
                    <div class="inpbox">
                      <el-input
                        name="username"
                        placeholder="请输入手机号"
                        v-model="email"
                        class="inp"
                      ></el-input>
                    </div>
                  </div>
                </div>
                <div class="li li2">
                  <div class="info">短信验证码</div>
                  <div class="con con-code">
                    <div class="inpbox">
                      <el-input
                          name="vercode"
                        placeholder="请输入短信验证码"
                        v-model="vercode"
                        class="inp"
                      ></el-input>
                    </div>
                    <div class="btn-code">
                    <button :disabled="isCountingDown" @click="getCaptcha" class="code">获取验证码</button>
                    <p v-if="isCountingDown" class="num">剩余{{ countdown }}秒</p>
                  </div>
                    <!-- <div class="code js-code">获取验证码</div> -->
                  </div>
                </div>
                <div class="li">
                  <div class="info">设置密码 </div>
                  <div class="con con-pass">
                    <div class="inpbox">
                      <el-input
                        placeholder="8-20位密码，字母/数字/符号至少2种"
                        v-model="password"
                        show-password
                        class="inp"
                      ></el-input>
                    </div>
                  </div>
                  <div class="con">
                    <div class="inpbox">
                      <el-input
                        placeholder="请再次确认您的密码"
                        v-model="password2"
                        show-password
                        class="inp"
                      ></el-input>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tips">
                <el-checkbox-group v-model="agreement">
                  <el-checkbox label="" name="agreement"></el-checkbox>
                </el-checkbox-group>
                <div class="txt">
                  登录或注册即代表同意
                  <a href="/home/index/protocol/type/bk_user_protocol.html" target="_blank" class="a">用户协议</a> 和
                  <a href="/home/index/protocol/type/bk_privacy_protocol.html" target="_blank" class="a">隐私政策</a>
                </div>
              </div>
              <button class="g-btns1" @click="submit">注 册</button>
            </form>
          </div>
        </div>
      </div>
      <div class="m-logdw" style="color: #9FA6AF;">
        Copyright ©
        <router-link to="/" class="a">{{ commonConfig.bk_config_copyright }}</router-link>
        <a href="https://beian.miit.gov.cn/" class="a" target="_blank">
          {{ commonConfig.bk_config_beian }}</a>
      </div>
    </div>
      <!-- <div class="m-signtips">
        注：注册后返回登录界面登录，首次登录后跳转到“会员中心--我的信息，提醒完善资料”
      </div> -->
  </div>
</template>

<script>
import {getApiRes, sleep} from "@/api/apiUtil";
import {register, sendMobileCode} from "@/api/user";

export default {
  components: {},
  data() {
    return {
      options: [
        {
          value: "0",
          label: "+86",
        },
      ],
      value: "+86",
      radio1: "1",
      type: 0,
      username: "",
      email: "",
      password: "",
      vercode: "",
      password2: "",
      select: "",
      agreement: [],
      isCountingDown: false, // 是否正在倒计时
      countdown: 60, // 倒计时秒数
      timer: null, // 定时器
    };
  },
  computed: {
    title(){
      if(this.type==0) return '会员注册'
      else if(this.type==1) return '供应商注册'
      else return '选书会员注册'
    }
  },

  mounted() {
    this.type = this.$route.query.type || 0
  },

  methods: {
    async submit(){
      if(this.agreement.length===0) return this.$message.error('请阅读并同意用户协议和隐私政策')
      if(!this.username) return this.$message.error('请输入真实姓名')
      if(!this.email) return this.$message.error('请输入手机号')
      if(!this.vercode) return this.$message.error('请输入短信验证码')
      if(!this.password) return this.$message.error('请输入密码')
      if(!this.password2) return this.$message.error('请再次输入密码')

      if(this.password !== this.password2) return this.$message.error('两次密码输入不一致')
      let data = {type:this.type, username: this.username,email:this.email, vercode:this.vercode, password: this.password, password2:this.password2}
      const re = await getApiRes(register(data),1,1,1,1)
      if(re.code===1){
        await sleep(1000)
        this.$router.push('/login')
      }
    },
    async getCaptcha() {
      if (this.isCountingDown) {
        return; // 如果正在倒计时，则不执行获取验证码操作
      }

      if(!this.email) return this.$message.error('请输入手机号')
      // 在这里执行获取验证码的操作，比如向服务器发送请求
      let re = await getApiRes(sendMobileCode(this.email), 0,1,1,1)
      if(re.code!==0) return

      // 开始倒计时
      this.isCountingDown = true;
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          // 倒计时结束，重置状态
          this.isCountingDown = false;
          this.countdown = 60;
          clearInterval(this.timer); // 清除定时器
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>




</style>
